import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { FieldType, FieldTypeConfig, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { InputGroup } from '@openng/optimus-ui/inputgroup';
import { InputGroupAddon } from '@openng/optimus-ui/inputgroupaddon';
import { InputMask } from '@openng/optimus-ui/inputmask';
import { FieldWrapperProps } from '../../wrappers/field-wrapper/field-wrapper.component';

interface InputMaskProps extends FieldWrapperProps {
  iconPre?: string;
  iconPost?: string;
  characterPattern?: string;
  mask?: string;
  slotChar?: string;
}

export interface InputMaskFieldConfig extends FormlyFieldConfig<InputMaskProps> {
  type?: 'input-mask' | Type<InputMaskTypeComponent>;
}

@Component({
  selector: 'lib-input-mask-type',
  templateUrl: './input-mask-type.component.html',
  styleUrl: './input-mask-type.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslocoDirective,
    NgClass,
    InputGroup,
    InputGroupAddon,
    InputMask,
    ReactiveFormsModule,
    FormlyModule
  ]
})
export class InputMaskTypeComponent extends FieldType<FieldTypeConfig<InputMaskProps>> {}
